<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Other Allen Drury Titles<br/>from WordFire</span></p>
<p class="P_WFP_OtherTitles__And__Bold"><span>The Advise and Consent series</span></p>
<p class="P_WFP_OtherTitles"><span>Advise and Consent</span></p>
<p class="P_WFP_OtherTitles"><span>A Shade of Difference</span></p>
<p class="P_WFP_OtherTitles"><span>Capable of Honor</span></p>
<p class="P_WFP_OtherTitles"><span>Preserve and Protect</span></p>
<p class="P_WFP_OtherTitles"><span>Come Nineveh, Come Tyre</span></p>
<p class="P_WFP_OtherTitles"><span>The Promise of Joy</span></p>
<p class="P_WFP_OtherTitles"><span> </span></p>
<p class="P_WFP_OtherTitles__And__14pt__And__Bold__And__No_Italic"><span>Other Novels</span></p>
<p class="P_WFP_OtherTitles"><span>Decision</span></p>
<p class="P_WFP_OtherTitles"><span>Mark Coffin, U.S.S.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?54024a41